import BaseListPresenter from "../../../../base/BaseListPresenter";
import { getCurrentUserUseCase } from "../../../../usecases/user";

class GrossTotalTransacPresenter extends BaseListPresenter {
  init() {
    this.store = [];
    // this.limit = 2000000;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterDate = {};
    this.filterStore = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async findObjects() {
    try {
      const user = await getCurrentUserUseCase().execute();
      const storeQuery = {
        include: ["all"],
        where: { email: user.email },
      };
      this.store = await this.findObjectUseCase.execute("users", storeQuery);

      const store = this.store[0].storeAnalytic.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      this.view.setStore(store);
    } catch (error) {
      console.error("Error fetching user or store data:", error);
      return;
    }

    const skip = (this.current - 1) * this.limit;
    const storeCodes = this.store?.flatMap((storeItem) =>
      storeItem.storeAnalytic?.map((analytic) => analytic?.name)
    );

    const query = {
      // limit: 800000,
      skip: skip,
      where: {
        store_code:
          this.filterStore === "AllStore"
            ? { $in: storeCodes }
            : this.filterStore,
        tran_date: this.filterDate && this.filterDate,
      },
      include: ["all"],
      sort: this.sort,
      keys: [
        "store_code",
        "tran_date",
        "total",
        "total_tax",
        "discount_amount",
        "createdAt",
        "cust_name",
        "status",
        // "items",
      ],
    };

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      // const objects = await this.findObjectUseCase.execute(
      //   this.view.getCollectionName(),
      //   query
      // );

      if (Object.keys(this.filterStore).length === 0) {
        console.log("data");
      } else {
        const { count } = await this.countObjectUseCase.execute(
          this.view.getCollectionName(),
          { where: query.where }
        );

        this.count = count;
        console.log("this.count", this.count);
        this.view.setCount(this.count);

        let timeoutId = null;

        // Handle delayed "not found"
        if (this.count === 0) {
          timeoutId = setTimeout(() => {
            if (this.count === 0) {
              this.view.setNotFound(true);
              this.view.setObjects([]);
              this.view.setTotal(0);
            }
          }, 30000); // 15 seconds delay
        }

        // Batching logic
        let buffer = [];

        const flushBuffer = () => {
          if (buffer.length > 0) {
            this.view.setState((prevState) => ({
              objects: [...prevState.objects, ...buffer],
            }));
            this.objects = this.objects.concat(buffer);
            this.view.setTotal(this.objects.length);
            this.view.setObjects(this.objects);
            buffer = [];
          }
        };

        const onData = (objects) => {
          if (objects.length > 0 && timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
            this.view.setNotFound(false);
          }
          buffer.push(...objects);
        };

        const flushInterval = setInterval(flushBuffer, 2000);

        await this.findObjectUseCase.execute(
          this.view.getCollectionName(),
          query,
          {
            timeout: 100000,
            onData,
          }
        );

        clearInterval(flushInterval);
        flushBuffer();
        // this.objects = this.objects.concat(objects);
        // this.view.setTotal(this.objects.length);
        // this.view.setObjects(this.objects);
      }
    } catch (error) {
      console.error("Error fetching objects:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }

  onChangeStore(where) {
    this.filterStore = where;
    this.getObjects();
  }

  onChangeDate(where) {
    const timeStart = "05:00:00.000Z";
    const timeEnd = "04:59:59.999Z";

    try {
      const startDate = new Date(where.$gte);
      const endDate = new Date(where.$lte);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        throw new Error("Invalid date value");
      }

      const formattedStartDate = new Date(
        startDate.toISOString().split("T")[0] + "T" + timeStart
      );

      endDate.setUTCDate(endDate.getUTCDate() + 1);
      const formattedEndDate = new Date(
        endDate.toISOString().split("T")[0] + "T" + timeEnd
      );

      const createdAts = {
        $gte: formattedStartDate.toISOString(),
        $lte: formattedEndDate.toISOString(),
      };

      console.log("GOGOGOG", createdAts);

      if (where !== "AllMonths" || !where) {
        this.filterDate = createdAts;
      } else {
        //null
        delete this.filterDate;
      }

      this.getObjects();
    } catch (error) {
      console.error("Error in onChangeDate:", error.message);
    }
  }
}

export default GrossTotalTransacPresenter;
